import React, { useState, useEffect } from 'react';
import { getLawyerPositions } from '../../services/api';

export default function PositionSelector({ onPositionChange, isLawyer = false }) {
  const [positions, setPositions] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const response = await getLawyerPositions();
        setPositions(response);
      } catch (error) {
        console.error('Error fetching positions:', error);
        // Fallback
        setPositions([
          { id_position: '1', position: 'Socio' },
          { id_position: '2', position: 'Asociado Senior' },
          { id_position: '3', position: 'Asociado' },
          { id_position: '4', position: 'Independiente' },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchPositions();
  }, []);

  const handleChange = e => {
    const value = e.target.value;
    setSelectedPosition(value);
    if (onPositionChange) {
      onPositionChange(value);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando posiciones...
      </div>
    );
  }

  return (
    <div className="relative">
      <select
        value={selectedPosition}
        onChange={handleChange}
        className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none ${
          isLawyer
            ? 'bg-transparent border-gray-400 text-white focus:ring-gray-200'
            : 'bg-white border-gray-300 text-gray-900'
        }`}
      >
        <option value="">Seleccione posición</option>
        {positions.map(position => (
          <option key={position.id_position} value={position.id_position}>
            {position.position}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
}
